export default {
  SET_MARKETING_LIST: 'SET_MARKETING_LIST',
  GET_MARKETING_LIST: 'GET_MARKETING_LIST',
};
